

// Funciones para recuperar IMG en el stepper
export const getStepperConselleriaIMG = (idConselleria:number|undefined) => {
    if(idConselleria){
        return `https://atib.es/App_Themes/Default/imgs/conselleries/conselleria_${idConselleria}.png`
    }
    return  'https://atib.es/App_Themes/Default/imgs/conselleries/conselleria_govern.png'
}